import { createRootRoute, Outlet } from '@tanstack/react-router'
import Logo from '@tandem/ui/Тандем.svg?react'
import styles from '../App.module.css'

export const Route = createRootRoute({
  component: RootLayout
})

function RootLayout() {
  return (
    <>
      <header className={styles.header}>
        <div className={styles.container}>
          <a href='/' className={styles.logo}>
            <Logo />
          </a>
          <nav>
            <a href={`${env.BUSINESS_APP_URL}/login`} className={styles.cta}>
              Войти
            </a>
          </nav>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <div className={styles.container}>
          <p>&copy; 2026 Тандем</p>
        </div>
      </footer>
    </>
  )
}
